import 'css-chunksrc/client/scenes/calendar/week/holiday/styles.scss';export default {
  "holiday": "_holiday_gz71q_1",
  "background": "_background_gz71q_8",
  "main": "_main_gz71q_18",
  "icon": "_icon_gz71q_30",
  "name": "_name_gz71q_36"
};